// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/wave-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/icons/diamondIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/icons/carousel-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/icons/settings.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/icons/iconBell.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.strategyContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
  width: 100%;
  min-height: calc(var(--vh, 1dvh) * 100);
  touch-action: pan-y;
  background-image: linear-gradient(180deg, rgba(0, 84, 130, 0.87), rgb(0, 47, 72)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat-x;
  overflow-y: auto;
  overflow-x: hidden;
}
.strategyContainer .glowFlame {
  position: absolute;
  margin-left: 80px;
}
.strategyContainer .glowFlame .flame {
  width: 50px;
  height: 50px;
  background: linear-gradient(-45deg, red, orange);
  border-radius: 50px 50px 0px 50px;
  transform: rotate(-135deg);
  animation: 1s flame infinite;
  filter: blur(10px);
  position: relative;
  box-shadow: 17px 20px 90px #700;
  border: 50px 50px 0px 50px solid black;
  border-left-width: 25px;
  border-top-width: 25px;
}
.strategyContainer .glowFlame .flame:after, .strategyContainer .glowFlame .flame:before {
  content: "";
  width: 100px;
  height: 100px;
  display: block;
  position: absolute;
  background: linear-gradient(-45deg, red, orange);
  animation: 1s flame infinite;
  transform: scale(0.8) rotate(20deg);
  border-radius: 100px 100px 0px 100px;
  top: 10px;
}
.strategyContainer .glowFlame .flame:before {
  top: 0;
  animation-duration: 0.7s;
  transform: scale(0.9) rotate(-15deg) translate(10px, 0px);
}
@keyframes flame {
  0% {
    height: 50px;
    width: 50px;
  }
  50% {
    height: 40px;
    width: 40px;
  }
  100% {
    height: 50px;
    width: 50px;
  }
}
.strategyContainer .actualDiamond {
  display: flex;
  align-items: center;
}
.strategyContainer .actualDiamond p {
  color: #FFFFFF;
  font-family: "Crimson Pro", serif;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  font-size: 24px;
}
.strategyContainer .actualDiamond img {
  position: relative;
  z-index: 2;
  margin-left: 5px;
}
.strategyContainer .curtain {
  height: 150px;
  width: 100%;
  border-radius: 0px 0px 16px 16px;
  background: linear-gradient(90deg, #6D4ECB, #FF6B6B);
  box-shadow: 0px 13px 11px 0px rgba(0, 41, 64, 0.5);
  overflow: hidden;
  position: relative;
}
@media (max-height: 700px) {
  .strategyContainer .curtain {
    height: 20dvh;
  }
}
@media (min-width: 450px) {
  .strategyContainer .curtain {
    width: 400px;
  }
}
.strategyContainer .curtain .curtainPlan {
  display: flex;
  gap: 5px;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
}
@media (max-height: 700px) {
  .strategyContainer .curtain .curtainPlan {
    height: 40px;
  }
}
.strategyContainer .curtain .curtainPlan .gold {
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 140%; /* 22.4px */
  background: -webkit-linear-gradient(0deg, #e2a556 1.2%, #eedcbb, #f8bc67);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.strategyContainer .curtain .curtainPlan .simple {
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 140%; /* 22.4px */
  background: -webkit-linear-gradient(0deg, #efdbc2 1.2%, #8fa3b0, rgb(155, 202, 246));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.strategyContainer .curtain .userBalanceBlock {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5%;
}
.strategyContainer .curtain .userBalanceBlock .dollarSign {
  color: #FFFFFF;
  font-family: "Bitter", serif;
  font-size: 36.474px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  opacity: 0.6;
  mix-blend-mode: overlay;
  margin-bottom: -5px;
}
.strategyContainer .curtain .userBalanceBlock .userBalanceNum {
  color: #FFFFFF;
  font-family: "Bitter", serif;
  font-size: 53px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 11px;
  margin-top: 64px;
}
@media only screen and (max-height: 712px) {
  .strategyContainer .curtain .userBalanceBlock .userBalanceNum {
    font-size: 43px;
  }
}
.strategyContainer .curtain .diagonalBlink {
  width: 149.455px;
  float: right;
  margin-top: -240px;
  margin-right: 25px;
  height: 518px;
  transform: rotate(30deg);
  background: linear-gradient(90deg, rgba(217, 217, 217, 0) 0%, rgba(255, 255, 255, 0.33) 47.47%, rgba(217, 217, 217, 0) 100%);
}
.strategyContainer .curtain .dissapearNumbers {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  margin-right: 10px;
  right: 1px;
  bottom: 15px;
}
.strategyContainer .curtain .dissapearNumbers div {
  display: inline-flex;
  height: 24px;
  padding: 1px 8px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.3);
  mix-blend-mode: overlay;
  color: #fff;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 6px;
}
.strategyContainer .curtain .dissapearNumbers .first {
  margin-right: 5px;
  opacity: 0.1;
}
.strategyContainer .curtain .dissapearNumbers .second {
  margin-right: 0px;
  opacity: 0.3;
}
.strategyContainer .curtain .dissapearNumbers .third {
  margin-right: 24px;
  opacity: 0.8;
}
.strategyContainer .curtain .dissapearNumbers .fourth {
  margin-right: 12px;
}
.strategyContainer .strategyViewBlock {
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.strategyContainer .strategyViewBlock .countdownTimer {
  font-size: 22px;
  color: #FFFFFF;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  gap: 10px;
}
.strategyContainer .strategyViewBlock .countdownTimer .startMining {
  background: gray;
  padding-left: 10px;
  padding-right: 10px;
  color: #FFFFFF;
  font-family: "Crimson Pro", serif;
}
.strategyContainer .strategyViewBlock .startMining {
  all: unset;
  text-align: center;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  height: 48px;
  color: white;
  border: 0px solid gray;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
}
.strategyContainer .strategyViewBlock .switcherBlock {
  width: 300px;
  height: 53px;
  margin: 0 auto;
  flex-shrink: 0;
  border-radius: 35.81px;
  margin-top: 10px;
  background: #002F48;
  box-shadow: 0px 1px 0px 0px rgba(255, 255, 255, 0.2), 0px 1px 0px 0px rgba(0, 0, 0, 0.3) inset;
  position: relative;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 265px;
  height: 4px;
  position: absolute;
  top: 45%;
  left: 6%;
  background: linear-gradient(90deg, #8453f7 13.33%, #FF6B6B 82.89%);
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .option {
  transition: all 0.3s;
  position: relative;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .option::before {
  content: "";
  position: absolute;
  width: 100px;
  height: 100px;
  top: -20px;
  right: -20px;
  bottom: -20px;
  left: -20px;
  z-index: 2;
}
@keyframes grow {
  0% {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  100% {
    width: 200px;
    height: 200px;
    border-radius: 50%;
  }
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .option.animate {
  animation: grow 0.3s ease;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .neutralOption {
  width: 20px;
  height: 20px;
  border-radius: 34px;
  background: #8453f7;
  position: absolute;
  left: 0;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .relaxOption {
  width: 20px;
  height: 20px;
  border-radius: 34px;
  background: #b15bc4;
  position: absolute;
  left: 29%;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .balancedOption {
  width: 20px;
  height: 20px;
  border-radius: 34px;
  position: absolute;
  right: 30%;
  background: #c165b2;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .aggressiveOption {
  width: 20px;
  height: 20px;
  border-radius: 34px;
  background: #ea6784;
  position: absolute;
  right: 0px;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .selected {
  width: 55px;
  height: 55px;
  margin-left: -17px;
  border-radius: 50%;
  border: 4px solid #FFFFFF;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .selected:not(.balancedOption) {
  right: -16px;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .selected.balancedOption {
  /* Your styles here */
  right: 24%;
}
.strategyContainer .strategyViewBlock .switcherBlock .switcherLine .selected:not(.balancedOption) {
  right: -16px;
}
.strategyContainer .strategyViewBlock .swithcerLabels {
  display: flex;
  justify-content: space-between;
  width: 275px;
  left: 3%;
  position: absolute;
  top: 58px;
}
.strategyContainer .strategyViewBlock .swithcerLabels div:nth-child(2) {
  margin-left: -10px;
}
.strategyContainer .strategyViewBlock .swithcerLabels .labelText {
  color: #699BB6;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}
.strategyContainer .strategyViewBlock .swithcerLabels .labelLine {
  width: 1px;
  height: 10px;
  margin: 0 auto;
  background-color: #699BB6;
}
.strategyContainer .strategyViewBlock .menuIcons {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 250px;
  left: 8%;
  position: absolute;
  top: 120px;
}
.strategyContainer .strategyViewBlock .menuIcons div {
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 40px;
  background: rgba(33, 107, 147, 0.3);
}
.strategyContainer .strategyViewBlock .menuIcons .diamonds {
  padding: 10px;
  background-position: center;
  background-size: 70%;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.strategyContainer .strategyViewBlock .menuIcons .diamonds svg {
  fill: red;
}
.strategyContainer .strategyViewBlock .menuIcons .plans {
  background-position: center;
  background-size: 80%;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  position: relative;
}
.strategyContainer .strategyViewBlock .menuIcons .settings {
  background-position: center;
  background-size: 80%;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  position: relative;
}
.strategyContainer .strategyViewBlock .menuIcons .notifications {
  background-position: center;
  background-size: 80%;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  position: relative;
}
.strategyContainer .strategyViewBlock .menuIcons .notificationDot {
  top: 0;
  right: 0;
  height: 10px;
  width: 10px;
  background-color: #FF6B6B;
  border-radius: 50%;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/modules/home/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,uCAAA;EACA,mBAAA;EACA,0HAAA;EAEA,2BAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAGE;EACE,kBAAA;EACA,iBAAA;AADJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,gDAAA;EACA,iCAAA;EACA,0BAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,sCAAA;EACA,uBAAA;EACA,sBAAA;AAAN;AAEM;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gDAAA;EACA,4BAAA;EACA,mCAAA;EACA,oCAAA;EACA,SAAA;AADR;AAGM;EACE,MAAA;EACA,wBAAA;EACA,yDAAA;AADR;AAME;EACE;IACE,YAAA;IACA,WAAA;EAJJ;EAME;IACE,YAAA;IACA,WAAA;EAJJ;EAME;IACE,YAAA;IACA,WAAA;EAJJ;AACF;AAME;EACE,aAAA;EACA,mBAAA;AAJJ;AAKI;EACE,cCxEO;EDyEP,iCEvEQ;EFwER,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAHN;AAKI;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;AAHN;AAME;EACE,aAAA;EAOA,WAAA;EACA,gCAAA;EACA,oDAAA;EACA,kDAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;AADI;EAFF;IAGI,aAAA;EAIJ;AACF;AAHI;EALF;IAMI,YAAA;EAMJ;AACF;AACI;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EAKA,mBAAA;EACA,uBAAA;AAHN;AAFM;EAJF;IAKI,YAAA;EAKN;AACF;AADM;EACE,kBAAA;EACA,iCE1GC;EF2GD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,yEAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAGR;AADM;EACE,kBAAA;EACA,iCEtHC;EFuHD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,oFAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAGR;AAAI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAEN;AAAM;EACE,cC7IK;ED8IL,4BE7IC;EF8ID,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAER;AAAM;EACE,cCxJK;EDyJL,4BExJC;EFyJD,eAAA;EAIA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AADR;AANQ;EAJF;IAKI,eAAA;EASR;AACF;AADI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,4HAAA;AAGN;AAII;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAFN;AAGM;EACE,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;EACA,uBAAA;EACA,WAAA;EACA,iCErMC;EFsMD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADR;AAGM;EACE,iBAAA;EACA,YAAA;AADR;AAGM;EACE,iBAAA;EACA,YAAA;AADR;AAGM;EACE,kBAAA;EACA,YAAA;AADR;AAGM;EACE,kBAAA;AADR;AAKE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAII;EACE,eAAA;EACA,cC1OO;ED4OP,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAHN;AAIM;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cCpPK;EDqPL,iCEnPM;AFiPd;AAMI;EACE,UAAA;EACA,kBAAA;EAEA,uDAAA;EAEA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AANN;AAQI;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBC5Qc;ED6Qd,8FACE;EAEF,kBAAA;AARN;AASM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,kEAAA;AAPR;AASQ;EACE,oBAAA;EACA,kBAAA;AAPV;AAUQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AARV;AAWQ;EACE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EATV;EAWQ;IACE,YAAA;IACA,aAAA;IACA,kBAAA;EATV;AACF;AAWQ;EACE,yBAAA;AATV;AAWQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;AATV;AAWQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AATV;AAWQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AATV;AAWQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AATV;AAYQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAVV;AAYQ;EACE,YAAA;AAVV;AAYQ;EACE,qBAAA;EACA,UAAA;AAVV;AAYQ;EACE,YAAA;AAVV;AAcI;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;AAZN;AAaM;EACE,kBAAA;AAXR;AAcM;EACE,cC9XS;ED+XT,kBAAA;EACA,iCE5XC;EF6XD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAZR;AAcM;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBC3YS;AD+XjB;AAeI;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;AAbN;AAcM;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,mCAAA;AAZR;AAcM;EACE,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yDAAA;AAZR;AAcQ;EACE,SAAA;AAZV;AAeM;EACE,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yDAAA;EACA,kBAAA;AAbR;AAeM;EACE,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yDAAA;EACA,kBAAA;AAbR;AAeM;EACE,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yDAAA;EACA,kBAAA;AAbR;AAeM;EACE,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yBCncY;EDocZ,kBAAA;EACA,kBAAA;AAbR","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.strategyContainer {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  position: fixed;\n  width: 100%;\n  min-height: calc(var(--vh, 1dvh) * 100);\n  touch-action: pan-y;\n  background-image: linear-gradient(180deg, rgba(0, 84, 130, 0.87), rgba(0, 47, 72, 1)),\n    url('../../assets/img/wave-pattern.png');\n  background-repeat: repeat-x;\n  overflow-y: auto;\n  overflow-x: hidden;\n  .glowFlame {\n    position: absolute;\n    margin-left: 80px;\n    .flame {\n      width: 50px;\n      height: 50px;\n      background: linear-gradient(-45deg, red, orange);\n      border-radius: 50px 50px 0px 50px;\n      transform: rotate(-135deg);\n      animation: 1s flame infinite;\n      filter: blur(10px);\n      position: relative;\n      box-shadow: 17px 20px 90px #700;\n      border: 50px 50px 0px 50px solid black;\n      border-left-width: 25px;\n      border-top-width: 25px;\n\n      &:after,\n      &:before {\n        content: '';\n        width: 100px;\n        height: 100px;\n        display: block;\n        position: absolute;\n        background: linear-gradient(-45deg, red, orange);\n        animation: 1s flame infinite;\n        transform: scale(0.8) rotate(20deg);\n        border-radius: 100px 100px 0px 100px;\n        top: 10px;\n      }\n      &:before {\n        top: 0;\n        animation-duration: 0.7s;\n        transform: scale(0.9) rotate(-15deg) translate(10px, 0px);\n      }\n    }\n  }\n\n  @keyframes flame {\n    0% {\n      height: 50px;\n      width: 50px;\n    }\n    50% {\n      height: 40px;\n      width: 40px;\n    }\n    100% {\n      height: 50px;\n      width: 50px;\n    }\n  }\n  .actualDiamond {\n    display: flex;\n    align-items: center;\n    p {\n      color: $color-White;\n      font-family: $Crimson-Pro;\n      font-weight: 600;\n      line-height: 140%;\n      text-align: center;\n      font-size: 24px;\n    }\n    img {\n      position: relative;\n      z-index: 2;\n      margin-left: 5px;\n    }\n  }\n  .curtain {\n    height: 150px;\n    @media (max-height: 700px) {\n      height: 20dvh;\n    }\n    @media (min-width: 450px) {\n      width: 400px;\n    }\n    width: 100%;\n    border-radius: 0px 0px 16px 16px;\n    background: linear-gradient(90deg, $color-Gradient-3-1, $color-Gradient-2-2);\n    box-shadow: 0px 13px 11px 0px rgba(0, 41, 64, 0.5);\n    overflow: hidden;\n    position: relative;\n    .curtainPlan {\n      display: flex;\n      gap: 5px;\n      margin-top: 10px;\n      @media (max-height: 700px) {\n        height: 40px;\n      }\n\n      align-items: center;\n      justify-content: center;\n      .gold {\n        text-align: center;\n        font-family: $Roboto;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 140%; /* 22.4px */\n        background: -webkit-linear-gradient(0deg, #e2a556 1.2%, #eedcbb, #f8bc67);\n        background-clip: text;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n      }\n      .simple {\n        text-align: center;\n        font-family: $Roboto;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 140%; /* 22.4px */\n        background: -webkit-linear-gradient(0deg, #efdbc2 1.2%, #8fa3b0, rgb(155, 202, 246));\n        background-clip: text;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n      }\n    }\n    .userBalanceBlock {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 5%;\n\n      .dollarSign {\n        color: $color-White;\n        font-family: $Bitter;\n        font-size: 36.474px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        opacity: 0.6;\n        mix-blend-mode: overlay;\n        margin-bottom: -5px;\n      }\n      .userBalanceNum {\n        color: $color-White;\n        font-family: $Bitter;\n        font-size: 53px;\n        @media only screen and (max-height: 712px) {\n          font-size: 43px;\n        }\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        margin-left: 11px;\n        margin-top: 64px;\n      }\n    }\n    .diagonalBlink {\n      width: 149.455px;\n      float: right;\n      margin-top: -240px;\n      margin-right: 25px;\n      height: 518px;\n      transform: rotate(30deg);\n      background: linear-gradient(\n        90deg,\n        rgba(217, 217, 217, 0) 0%,\n        rgba(255, 255, 255, 0.33) 47.47%,\n        rgba(217, 217, 217, 0) 100%\n      );\n    }\n    .dissapearNumbers {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      justify-content: flex-end;\n      margin-right: 10px;\n      right: 1px;\n      bottom: 15px;\n      div {\n        display: inline-flex;\n        height: 24px;\n        padding: 1px 8px;\n        justify-content: center;\n        align-items: center;\n        gap: 5px;\n        flex-shrink: 0;\n        border-radius: 20px;\n        background: rgba(255, 255, 255, 0.3);\n        mix-blend-mode: overlay;\n        color: #fff;\n        font-family: $Roboto;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 18px;\n        margin-bottom: 6px;\n      }\n      .first {\n        margin-right: 5px;\n        opacity: 0.1;\n      }\n      .second {\n        margin-right: 0px;\n        opacity: 0.3;\n      }\n      .third {\n        margin-right: 24px;\n        opacity: 0.8;\n      }\n      .fourth {\n        margin-right: 12px;\n      }\n    }\n  }\n  .strategyViewBlock {\n    width: 400px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    .countdownTimer {\n      font-size: 22px;\n      color: $color-White;\n      // background: rgba(0, 0, 0, 0.7);\n      padding: 10px;\n      border-radius: 5px;\n      display: flex;\n      gap: 10px;\n      .startMining {\n        background: gray;\n        padding-left: 10px;\n        padding-right: 10px;\n        color: $color-White;\n        font-family: $Crimson-Pro;\n      }\n    }\n\n    .startMining {\n      all: unset;\n      text-align: center;\n      // display: inline-block;\n      background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n      // cursor: pointer;\n      height: 48px;\n      color: white;\n      border: 0px solid gray;\n      padding-left: 20px;\n      padding-right: 20px;\n      margin-top: 10px;\n      margin-bottom: 10px;\n      border-radius: 10px;\n    }\n    .switcherBlock {\n      width: 300px;\n      height: 53px;\n      margin: 0 auto;\n      flex-shrink: 0;\n      border-radius: 35.81px;\n      margin-top: 10px;\n      background: $color-Gradient-1-2;\n      box-shadow:\n        0px 1px 0px 0px rgba(255, 255, 255, 0.2),\n        0px 1px 0px 0px rgba(0, 0, 0, 0.3) inset;\n      position: relative;\n      .switcherLine {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 265px;\n        height: 4px;\n        position: absolute;\n        top: 45%;\n        left: 6%;\n        background: linear-gradient(90deg, #8453f7 13.33%, $color-Gradient-2-2 82.89%);\n\n        .option {\n          transition: all 0.3s;\n          position: relative;\n        }\n\n        .option::before {\n          content: '';\n          position: absolute;\n          width: 100px;\n          height: 100px;\n          top: -20px;\n          right: -20px;\n          bottom: -20px;\n          left: -20px;\n          z-index: 2;\n        }\n\n        @keyframes grow {\n          0% {\n            width: 50px;\n            height: 50px;\n            border-radius: 50%;\n          }\n          100% {\n            width: 200px;\n            height: 200px;\n            border-radius: 50%;\n          }\n        }\n        .option.animate {\n          animation: grow 0.3s ease;\n        }\n        .neutralOption {\n          width: 20px;\n          height: 20px;\n          border-radius: 34px;\n          background: #8453f7;\n          position: absolute;\n          left: 0;\n        }\n        .relaxOption {\n          width: 20px;\n          height: 20px;\n          border-radius: 34px;\n          background: #b15bc4;\n          position: absolute;\n          left: 29%;\n        }\n        .balancedOption {\n          width: 20px;\n          height: 20px;\n          border-radius: 34px;\n          position: absolute;\n          right: 30%;\n          background: #c165b2;\n        }\n        .aggressiveOption {\n          width: 20px;\n          height: 20px;\n          border-radius: 34px;\n          background: #ea6784;\n          position: absolute;\n          right: 0px;\n        }\n\n        .selected {\n          width: 55px;\n          height: 55px;\n          margin-left: -17px;\n          border-radius: 50%;\n          border: 4px solid $color-White;\n        }\n        .selected:not(.balancedOption) {\n          right: -16px;\n        }\n        .selected.balancedOption {\n          /* Your styles here */\n          right: 24%;\n        }\n        .selected:not(.balancedOption) {\n          right: -16px;\n        }\n      }\n    }\n    .swithcerLabels {\n      display: flex;\n      justify-content: space-between;\n      width: 275px;\n      left: 3%;\n      position: absolute;\n      top: 58px;\n      div:nth-child(2) {\n        margin-left: -10px;\n      }\n\n      .labelText {\n        color: $color-Secondary;\n        text-align: center;\n        font-family: $Roboto;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        text-transform: uppercase;\n      }\n      .labelLine {\n        width: 1px;\n        height: 10px;\n        margin: 0 auto;\n        background-color: $color-Secondary;\n      }\n    }\n    .menuIcons {\n      display: flex;\n      justify-content: space-between;\n      margin: 0 auto;\n      width: 250px;\n      left: 8%;\n      position: absolute;\n      top: 120px;\n      div {\n        display: flex;\n        width: 40px;\n        height: 40px;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        flex-shrink: 0;\n        border-radius: 40px;\n        background: rgba(33, 107, 147, 0.3);\n      }\n      .diamonds {\n        padding: 10px;\n        background-position: center;\n        background-size: 70%;\n        background-repeat: no-repeat;\n        background-image: url('../../assets/icons/diamondIcon.svg');\n\n        svg {\n          fill: red;\n        }\n      }\n      .plans {\n        background-position: center;\n        background-size: 80%;\n        background-repeat: no-repeat;\n        background-image: url('../../assets/icons/carousel-icon.svg');\n        position: relative;\n      }\n      .settings {\n        background-position: center;\n        background-size: 80%;\n        background-repeat: no-repeat;\n        background-image: url('../../assets/icons/settings.svg');\n        position: relative;\n      }\n      .notifications {\n        background-position: center;\n        background-size: 80%;\n        background-repeat: no-repeat;\n        background-image: url('../../assets/icons/iconBell.svg');\n        position: relative;\n      }\n      .notificationDot {\n        top: 0;\n        right: 0;\n        height: 10px;\n        width: 10px;\n        background-color: $color-Gradient-2-2;\n        border-radius: 50%;\n        position: absolute;\n      }\n    }\n  }\n}\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
